const moment = require('moment')

export default {
  namespaced: true,
  state: {
    items: [],
    types: [
      {
        value: "out-of-order",
        text: "Hors service"
      },
      {
        value: "lost",
        text: "Perdu"
      },
      {
        value: "stolen",
        text: "Volé"
      },
      {
        value: "product-error",
        text: "Erreur de produit"
      },
      {
        value: "delivery-problem",
        text: "Problème de livraison"
      },
      {
        value: "delivery-delay",
        text: "Retard de livraison"
      },
      {
        value: "withdrawal-problem",
        text: "Problème d'enlèvement"
      },
      {
        value: "return-content-error",
        text: "Erreur sur le matériel repris"
      },
      {
        value: "transfer-error",
        text: "Erreur de transfert"
      },
      {
        value: "equipment-malfunction",
        text: "Panne / dysfonctionnement"
      },
      {
        value: "other",
        text: "Autre"
      }
    ],
    // Déclaration (perte, vol, hors service) ou réclamation : les deux parcours
    // du front-office partagent cette liste, seul `request_kind` les distingue.
    requestKinds: [
      {
        value: "declaration",
        text: "Déclaration"
      },
      {
        value: "complaint",
        text: "Réclamation"
      }
    ]
  },
  getters: {
    getAll: state => state.items,
    getByDate: state => (dateStart, dateEnd) => state.items.filter(item => moment(item.created_at).isBetween(moment(dateStart, dateEnd))),
    getItem: state => id => state.items.find(item => item.id == id),
    getTypes: state => state.types,
    getType: state => type => state.types.find(item => item.value == type),
    getRequestKinds: state => state.requestKinds,
    getRequestKind: state => kind => state.requestKinds.find(item => item.value == kind)
  },
  actions: {

    /**
     * Charge tous les items via l'API dans le state. Si des données sont déjà présentes dans le state, le résolve() est lancé de suite
     * @param   {boolean} wait  Si wait = true, on attends vraiment que les données soient reçues pour lancer le resolve() (impératif pour charger un formulaire de modification)
     * @returns {promise}       Aucune donnée n'est retournée
     */
    getAll: (context, wait = false) => {
      let params = {
        wait: wait,
        api_url: 'complaint',
        api_data_path: 'complaints',
        namespace: 'complaint'
      }
      return context.dispatch('getAll', params, {
        root: true
      })
    },
    getItem: (context, {
      id,
      wait = false
    }) => {
      let params = {
        wait: wait,
        api_url: 'complaint',
        namespace: 'complaint',
        id: id
      }
      return context.dispatch('getItem', params, {
        root: true
      })
    },
    saveItem(context, item) {
      let params = {
        api_url: 'complaint',
        namespace: 'complaint',
        item: item
      }
      return context.dispatch('saveItem', params, {
        root: true
      })
    },
    deleteItem(context, id) {
      let params = {
        api_url: 'complaint',
        namespace: 'complaint',
        id: id
      }
      return context.dispatch('deleteItem', params, {
        root: true
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/modules/complaint.js